import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const SolutionSection: React.FC = () => {
  return <section className="py-16 bg-green-900 text-white relative overflow-hidden" data-id="element-149">
      {/* Pattern overlay */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-150"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-151">
        <div className="max-w-4xl mx-auto text-center" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-153">
            Este pack está hecho para docentes reales
          </h2>
          <p className="text-green-100 text-lg md:text-xl mb-10" data-id="element-154">
            MegaPack Ciencias Naturales Lista es un pack digital premium
            diseñado para que tengas todo el año resuelto con material ordenado,
            imprimible y aplicable en el aula.
          </p>

          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 mb-10" data-id="element-155">
            <p className="text-xl font-medium mb-6" data-id="element-156">
              No es un PDF suelto. No es un compilado sin sentido. <br data-id="element-157" />
              <span className="text-amber-400" data-id="element-158">
                Es un sistema por unidades.
              </span>
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-left" data-id="element-159">
              {['Planificás más rápido', 'Enseñás con estructura', 'Tus clases se vuelven claras', 'Los estudiantes participan más', 'Evaluás sin complicarte'].map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-160">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-161" />
                  <span className="font-medium" data-id="element-162">{item}</span>
                </div>)}
            </div>
          </div>

          <CTAButton text="Quiero Ciencias lista todo el año" variant="primary" data-id="element-163" />
        </div>
      </div>
    </section>;
};